<div class="w-100 d-flex flex-column align-items-stretch">
  <gpay-ssb-batches-by-status></gpay-ssb-batches-by-status>
  <div class="w-100 d-flex flex-row align-items-stretch py-5 my-5">
    <div class="card-deck flex-grow-1">
      <div gpay-daily-throughput-widget></div>
      <div gpay-throughput-by-company-widget></div>
    </div>
  </div>
</div>
